import script from "./HomeMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeMobile.vue?vue&type=script&setup=true&lang=js"

import "./HomeMobile.vue?vue&type=style&index=0&id=523aab1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523aab1e"]])

export default __exports__